/* eslint-disable @typescript-eslint/naming-convention */
import { RxJsonSchema } from 'rxdb';
import { LocalCredentialsModel } from '../models';
import { CentralDatabaseKeys } from './central-database-keys';
import { AppVariables } from '@shared';

export const centralLocalCredentialsSchema: RxJsonSchema<LocalCredentialsModel> = {
	version: 0,
	primaryKey: CentralDatabaseKeys.localCredentials_username,
	properties: {
		[CentralDatabaseKeys.localCredentials_username]: {
			type: 'string',
			maxLength: AppVariables.PRIMARY_KEYS_MAX_LENGTH
		},
		[CentralDatabaseKeys.localCredentials_pin]: {
			type: 'string'
		},
		[CentralDatabaseKeys.localCredentials_failedAttempts]: {
			type: 'number'
		}
	},
	type: 'object',
	description: 'Store Fusion username, local PIN and failed attepts to login.'
};
